import { BIDCASEREVIEW } from '../constants';

export const queryBidCaseReviewLoad = () => {
    return {
        type: BIDCASEREVIEW.BIDCASEREVIEW_QUERY_LOAD
    }
}

export const queryBidCaseReview = (formData) => {
    return {
        type: BIDCASEREVIEW.BIDCASEREVIEW_QUERY,
        formData: formData
    }
}

export const queryBidCaseReviewSuccess = (token, result) => {
	sessionStorage.setItem('token', token);

    return {
        type: BIDCASEREVIEW.BIDCASEREVIEW_QUERY_SUCCESS,
        result: result
    }
}